import Sidebar from '../envelope/Sidebar';
import TopBar from '../envelope/TopBar';
import React, { useState } from 'react';
import TeorSoc from './TeorSoc';
import TeorLeader from './TeorLeader';
import TeorBelbin from './TeorBelbin';

const MethodologyPage = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [activeMethod, setActiveMethod] = useState('sociometry');

  return (
    <div className="dashboard">
      <Sidebar 
        isCollapsed={isSidebarCollapsed} 
        toggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)} 
      />
      <TopBar isCollapsed={isSidebarCollapsed} />
      
      <main className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <h1>Методология</h1>
        <div className="methodology-buttons">
          <button 
            className={`methodology-button ${activeMethod === 'sociometry' ? 'active' : ''}`}
            onClick={() => setActiveMethod('sociometry')}
          >
            Социометрия
          </button>
          <button 
            className={`methodology-button ${activeMethod === 'leader' ? 'active' : ''}`}
            onClick={() => setActiveMethod('leader')}
          >
            Лидерство
          </button>
          <button 
            className={`methodology-button ${activeMethod === 'belbin' ? 'active' : ''}`}
            onClick={() => setActiveMethod('belbin')}
          >
            Роль в команде
          </button>
        </div>
        
        <div className="content-container-text">
          {activeMethod === 'sociometry' && <TeorSoc />}
          {activeMethod === 'leader' && <TeorLeader />}
          {activeMethod === 'belbin' && <TeorBelbin />}
        </div>
      </main>
    </div>
  );
};

export default MethodologyPage;